import { Form, Modal } from "antd";
import React from "react";
import { CreateWasteApplication7RecordDto } from "../../../../api";
import { WasteApplication7RecordsColumns } from "../form/columns";

interface WasteApplication7RecordFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWasteApplication7Record: (values: CreateWasteApplication7RecordDto) => void;
}

export const WasteApplication7RecordForm: React.FC<WasteApplication7RecordFormProps> = ({ visible, setVisible, onCreateWasteApplication7Record }) => {
  const [form] = Form.useForm<CreateWasteApplication7RecordDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWasteApplication7Record}>
        {WasteApplication7RecordsColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
